import { Box, HStack, VStack, Text } from '@chakra-ui/react';
import { CheckCircle2 } from 'lucide-react';

import { djs } from '@duke-hq/djs';

import type { AssessmentSubmission } from './types';

export function AssessmentOverviewAssessed({
  assessmentSubmission,
}: {
  assessmentSubmission: Pick<AssessmentSubmission, 'outcome' | 'assessed_at' | 'assessedBy'>;
}) {
  return (
    <VStack w="full" flexDir="column" alignItems="center">
      <Box
        bg={assessmentSubmission.outcome === 'SATISFACTORY' ? 'green.500' : 'red.500'}
        borderWidth="1px"
        borderRadius="md"
        p={1}
        w="full"
      >
        <Box
          width="100%"
          height="100%"
          borderWidth="1px"
          borderRadius="md"
          borderColor="white"
          color="white"
          fontSize="sm"
          py={2}
          px={4}
        >
          <HStack>
            <CheckCircle2 />
            <VStack alignItems="start" spacing={0}>
              <Text fontWeight="bold">{assessmentSubmission.outcome.replace(/_/g, ' ')}</Text>
              <Text fontSize="xs">
                {djs(assessmentSubmission?.assessed_at).format('dddd, DD MMMM YYYY')}
              </Text>
            </VStack>
          </HStack>
        </Box>
      </Box>

      {assessmentSubmission?.assessedBy ? (
        <Text fontSize="xs" color="fg.muted">
          Assessed by:{' '}
          {`${assessmentSubmission?.assessedBy.first_name} ${assessmentSubmission?.assessedBy.last_name}`}
        </Text>
      ) : null}
    </VStack>
  );
}
